<template>
  <li :id="item.chatId">
    <div :class="index % 2 === 0 ? 'info_title' : 'info_title2'">
      <a style="color: #ffbc42;font-size: 14px">{{ item.userInfo.nickname }}</a>
      <a style="font-size: 14px;margin-top: 5px;font-weight: 333;color: #666666">{{ item.content }}</a>
    </div>
  </li>
</template>

<script>
export default {
  name: 'interaction-li',
  props: ['index', 'item'],
}
</script>
<style scoped>

.info_title {
  background-color: #ffffff;
  display: flex;
  padding-top: 5px;
  padding-bottom: 5px;
  padding-left: 10px;
  padding-right: 5px;
  flex-direction: column;
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
}

.info_title2 {
  background-color: #f9f9f9;
  display: flex;
  padding-top: 5px;
  padding-bottom: 5px;
  padding-left: 10px;
  padding-right: 5px;
  flex-direction: column;
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
}
</style>



// WEBPACK FOOTER //
// src/components/Video/InteractionLi.vue